<template>
    <div class="ppv2-bg-white dark:ppv2-bg-dark ppv2-rounded-3xl ppv2-p-6">
        <Header :title="$t('annonce.title')" />
        <AnnonceTable :user-id="userId" :token="token" />
    </div>
</template>

<script>
import AnnonceTable from './AnnonceTable.vue'
import Header from '../../../Shared/Header.vue'
import normalizeSize from '../../../../utils/normalizeSize'
import normalizeFontSize from '../../../../utils/normalizeFontSize'

export default {
    name: 'Annonce',
    props: {
        userId: {
            type: [Number, String],
            default: null,
        },
        token: {
            type: String,
            default: '',
        },
    },
    components: {
        AnnonceTable,
        Header,
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
    },
}
</script>
